export default __webpack_public_path__ + "static/media/rake.5ffd2c35.png";